Quiz.qwin =  {

	props: ['value'],

	data : function() {
		return {
			"visible": false,
			"bg": "",
			"state": 'summary',
			"title": "",
			"rules": "",
			"ranks": [],
			"id": "",
			"reg_text": "",
			"reg_link": "",
			"has_reg": false,

			"info": {},

			"question": "",
			"qphoto": "",
			"qcurrent": 0,
			"qtotal": 0,
			"answers": [],
			"shownextbutton": false,
			"correct": 0,
			"answered": 0,

			"winmsg": "",
			"winicon": "",
			"cansave": false,
			"totalTime": "",
			"rank": {},
			"result": "",

			"nickname": "",
			"nicknameerror": false,
			"time": "",
			"hasTitle": false,
			"big": ""
		};		
	},

	mounted: function() {
		SpeechManager.prepareTip("PLAYER.QUIZ.RANKINGS", "TIPS");
		SpeechManager.prepareTip("PLAYER.QUIZ.START", "TIPS");
		SpeechManager.prepareTip("PLAYER.QUIZ.NEW", "TIPS");
		SpeechManager.prepareTip("PLAYER.QUIZ.NEXT", "TIPS");
		SpeechManager.prepareTip("PLAYER.QUIZ.SAVE", "TIPS");
		SpeechManager.prepareTip("PLAYER.QUIZ.BACK", "TIPS");
		SpeechManager.prepareTip("PLAYER.QUIZ.A", "TIPS");
		SpeechManager.prepareTip("PLAYER.QUIZ.B", "TIPS");
		SpeechManager.prepareTip("PLAYER.QUIZ.C", "TIPS");
		SpeechManager.prepareTip("PLAYER.QUIZ.D", "TIPS");
	},

	methods: {
		open: function(id) {
			var self = this;
			this.state = "summary";

			this.id = id;
			this.hasTitle = false;

			ssi("quiz","info",{"id":id},function(resp) {
				
				//console.log(resp.data);
				self.title = resp.data.game.title;
				self.info = resp.data.game;
				self.rules = resp.data.game.rules.replace(/\n/g, "<br>");
				self.bg = "/storage/quiz/" + resp.data.game.background;
				self.visible = true;
				self.reg_text = resp.data.game.reg_text;
				self.reg_link = resp.data.game.reg_link;
				if ((self.reg_text != "" && self.reg_text != undefined) || (self.reg_link != "" && self.reg_link != undefined)) self.has_reg = true;
			});
		},

		reset: function() {
			this.state = 'summary';
			this.hasTitle = false;
		},

		startQuiz: function() {
			var self = this;

			this.hasTitle = true;

			ssi("quiz","info",{"id":this.id},function(resp) {
				self.start = new Date();
				self.info = resp.data.game;

				if (self.timer != undefined) {
					clearInterval(self.timer);
					self.timer = undefined;
				}

				self.timer = setInterval(function() {self.tick();}, 500);

				self.getNextQuestion();
			});			
		},

		stopQuiz: function() {
			if (this.timer != undefined) {
				clearInterval(this.timer);
				this.timer = undefined;
			}

			this.time = "";
		},

		tick: function() {
			var b = new Date();
			var tt = (b - this.start) * 0.001;
			var m = Math.floor(tt / 60);
			var s = Math.round(tt % 60);
			this.time = m + ":" + s;
		},

		getNextQuestion: function() {
			this.state = "question";
			var self = this;
			
			self.shownextbutton = false;

			ssi("quiz","nextQuestion",{"id": this.id}, function(resp) {
				console.log(resp.data);

				if (resp.data.finished != undefined) {
					//quiz.results();
					self.results();
				} else {
					self.question = resp.data.question;
					self.qcurrent = resp.data.question_number;
					self.qtotal = resp.data.total_questions;

					self.answers = [];

					if (resp.data.answer1 != "") self.answers.push({"text": resp.data.answer1, "s": "A"});
					if (resp.data.answer2 != "") self.answers.push({"text": resp.data.answer2, "s": "B"});
					if (resp.data.answer3 != "") self.answers.push({"text": resp.data.answer3, "s": "C"});
					if (resp.data.answer4 != "") self.answers.push({"text": resp.data.answer4, "s": "D"});
					if (resp.data.answer5 != "") self.answers.push({"text": resp.data.answer5, "s": "E"});

					if (resp.data.photo != "" && resp.data.photo != null) {
						self.qphoto = "/storage/quiz/" + resp.data.photo;						
					} else {
						self.qphoto = "";
					}
				}
			});

		},

		answer: function(idx) {
			var self = this;

			ssi("quiz","answer", {"id":this.id, "no": idx}, function(resp) {
				self.correct = resp.data.right_answer;
				self.answered = idx;

				self.shownextbutton = true;
			});
		},

		getBadge: function(good, total) {
			var winicon = "";
			var big = "";
			var cansave = false;
			var winmsg = "";

			//console.log(this.info.config);

			if (good == total) {winicon = '/storage/quiz/' + this.info.gold; big = '/storage/quiz/' + this.info.b_gold; cansave = true; winmsg = this.info.config.result100;}
			else if (good / total >= 0.85) {winicon = '/storage/quiz/' + this.info.silver ;big = '/storage/quiz/' + this.info.b_silver; cansave = true; winmsg = this.info.config.result85;}
			else if (good / total >= 0.75) {winicon = '/storage/quiz/' + this.info.bronze;big = '/storage/quiz/' + this.info.b_bronze; cansave = true; winmsg = this.info.config.result75;}
				
			else if (good / total >= 0.5) {winicon = '';cansave = true; winmsg = this.info.config.result50;}

			else if (good / total < 0.5) {winicon = ''; winmsg = this.info.config.result0;}

			return {
				"big": big,
				"winicon": winicon,
				"cansave": cansave,
				"winmsg": winmsg
			}
		},

		results: function() {
			this.state = "results";
			var self = this;
			this.hasTitle = true;

			self.cansave = false;

			this.stopQuiz();

			ssi("quiz","results",{},function(resp) {
				var rank = resp.data;
				var tt = resp.data.time;
				
				self.totalTime = Math.floor(tt / 60) + " min i " + (tt % 60) + " sek";
				self.rank = rank;

				self.winicon = "";
				self.result = Math.round(rank['good'] / rank['total'] * 100);
				var b = self.getBadge(rank['good'], rank['total']);
				self.winicon = b.winicon;
				self.cansave = b.cansave;
				self.winmsg = b.winmsg;
				/*
				if (rank['good'] == rank['total']) {self.winicon = '/storage/quiz/' + self.info.gold; self.cansave = true; self.winmsg = self.info.config.result100;}
				else if (rank['good'] / rank['total'] >= 0.85) {self.winicon = '/storage/quiz/' + self.info.silver; self.cansave = true; self.winmsg = self.info.config.result85;}
				else if (rank['good'] / rank['total'] >= 0.75) {self.winicon = '/storage/quiz/' + self.info.bronze; self.cansave = true; self.winmsg = self.info.config.result75;}
				
				else if (rank['good'] / rank['total'] >= 0.5) {self.winicon = '';self.cansave = true; self.winmsg = self.info.config.result50;}

				else if (rank['good'] / rank['total'] < 0.5) {self.winicon = ''; self.winmsg = self.info.config.result0;}
				*/

				//console.log(resp.data);
			});	
		},

		saveresults : function() {
			this.state = "saveresults";
			this.nicknameerror = false;
		},

		save : function() {
			var self = this;

			if (this.nickname != "") {
				ssi("quiz","addToRanking",{"nick": this.nickname},function(resp) {
					self.reset();
				});
			} else {
				this.nicknameerror = true;
			}
		},

		rankings: function() {
			this.state = "rankings";
			
			var self = this;
					
			ssi("quiz","info",{"id":this.id},function(resp) {
				self.ranks = resp.data.ranking;
				for(var r in self.ranks) {
					b = self.getBadge(self.ranks[r].good, self.ranks[r].total);
					self.ranks[r].badge = b.winicon;
					self.ranks[r].big = b.big;
				}
			});


		},

		showBig: function(big) {
			this.big = big;
			this.state = "big";
		},

		reg: function() {
			this.state = "reg";
			
			var self = this;
					
		},

		close: function() {
			this.visible = false;
			this.stopQuiz();
		}
	},

	watch: {
	},

	template: '#tpl-qwin'
};